import React, { useState } from "react";
import { ref, set } from "firebase/database";
import { db } from "./firebase";
import { getNextStudentId } from "./studentIdGenerator";

const AddStudentForm = ({ courses, activeCourse, onStudentAdded }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [parentPhone, setParentPhone] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const studentId = await getNextStudentId();
      const studentData = {
        name,
        email,
        phone,
        parentPhone,
        studentId,
        enrolledCourse: activeCourse,
        student: true,
        role: "student",
        isLoggedIn: false
      };

      await set(ref(db, `courses/${activeCourse}/students/${studentId}`), studentData);

      alert(`Student added successfully with ID: ${studentId}`);
      setName("");
      setEmail("");
      setPhone("");
      setParentPhone("");
      onStudentAdded();
    } catch (error) {
      alert("Error adding student: " + error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white p-4 rounded-lg shadow-md">
      <h2 className="text-xl font-semibold mb-4">Add New Student</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1">Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full p-2 border rounded-md"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-2 border rounded-md"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Phone</label>
          <input
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            className="w-full p-2 border rounded-md"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Parent Phone</label>
          <input
            type="tel"
            value={parentPhone}
            onChange={(e) => setParentPhone(e.target.value)}
            className="w-full p-2 border rounded-md"
          />
        </div>
      </div>
      <div className="mt-4">
        <button
          type="submit"
          disabled={isSubmitting}
          className="bg-teal-600 text-white px-4 py-2 rounded-md hover:bg-teal-700 transition-colors disabled:bg-teal-400"
        >
          {isSubmitting ? "Adding..." : "Add Student"}
        </button>
      </div>
    </form>
  );
};

export default AddStudentForm;